var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotif09(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32.5599,
    height: 15.9953,
    viewBox: "0 0 32.5599 15.9953",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H16C24.8365 0 32 7.16143 32 15.9953H16C7.16352 15.9953 0 8.8339 0 0Z",
    fill: "#274766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.5599 7.99753H24.5195C28.9601 7.99753 32.5599 11.5782 32.5599 15.9952H24.6004C20.1596 15.9952 16.5599 12.4145 16.5599 7.99753Z",
    fill: "#86905B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif09);
export default __webpack_public_path__ + "static/media/motif-09.20329c44e6a20a0f7ed66b5e8a240d53.svg";
export { ForwardRef as ReactComponent };